// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "b3032aa-dirty",
    "hash": "b3032aa",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "b3032aa-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
